import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
import { CaptionLazy } from "../../_shared/figure/caption-renderer-lazy.js";
const ViewerImage = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_image_lazy" */
    "./viewer-image.js"
  )
);
const ImageRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    ViewerImage,
    {
      key: node.id,
      node,
      nodeIndex,
      NodeViewContainer,
      ...props
    }
  );
};
const ImageLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(ImageRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.IMAGE]: ImageLazy,
  [Node_Type.CAPTION]: CaptionLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
